const config = {
  MY_serviceId: "service_dghxd88",
  MY_templateId: "template_wz7q4wb",
  MY_userId: "user_4n0XowMSZDJ7Q6xCDEFOo",
};
export default config;
